<template>
<div data-seller_banner>
	<Swiper :modules="[Autoplay]" :loop="true" :autoplay="{'delay':3500,'disableOnInteraction':false}"
		@swiper="swiper=>{
			$window.setTimeout(()=>{
				swiper.slideNext();
				swiper.autoplay.start();
			}, 3500);
	}">
		<SwiperSlide v-for="banner in banner_list" :key="banner.bannerHeaderNo">
			<a :href="banner.headerLink" target="_blank" v-if="banner.headerLink" @click="()=>{
				Send({'method': 'GET','url': `/api/seller/v1/banner/bck/${banner.bannerClickKey}`})
			}">
				<img :src="banner.headerFile.fileLink" :alt="banner.headerFile.fileName"/>
			</a>
			<img :src="banner.headerFile.fileLink" :alt="banner.headerFile.fileName" v-else/>
		</SwiperSlide>
	</Swiper>
</div>
</template>
<script setup>
import{ computed }from"vue";
import{ useStore }from"vuex";
import{Swiper, SwiperSlide}from"swiper/vue";
import{ Autoplay }from"swiper/modules";
import"swiper/css";
import"swiper/css/autoplay";
import Send from"@/Send.js";

const $window = window;
const store = useStore();
const user_info = computed(()=>store.state.user_info);
const banner_list = computed(()=>user_info.value.sellerBannerHeaderList);
</script>
<style scoped lang="sass">
[data-seller_banner]
	display: flex
	width: 100%
	height: 192px
	position: relative
	overflow: hidden
.swiper-slide
	& > a, img
		width: 100%
		height: 100%
		object-fit: cover
</style>